export const DEFAULT_BUILD_NAME = 'My new creative build';
